import { z } from "zod";

/** Login: accept legacy passwords; only require non-empty input. */
export const loginPasswordSchema = z.string().min(1, "Password is required");

/**
 * New passwords (signup, reset, change-password): matches UI requirements.
 * Not used on login so grandfathered weak passwords still work.
 */
export const newPasswordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters")
  .max(30, "Password must be at most 30 characters")
  .regex(/[a-z]/, "Password must include a lowercase letter")
  .regex(/[A-Z]/, "Password must include an uppercase letter")
  .regex(/[0-9]/, "Password must include a number")
  .regex(/[^A-Za-z0-9]/, "Password must include a special character");

export const normalizedEmailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .min(1, "Email is required")
  .email("Invalid email address");

export const makeAuthNameSchema = (fieldLabel = "Name") =>
  z
    .string()
    .trim()
    .min(1, `${fieldLabel} is required`)
    .min(2, `${fieldLabel} must be at least 2 characters`)
    .max(50, `${fieldLabel} must be at most 50 characters`)
    .regex(/^[\p{L}\s'-]+$/u, "Use letters, spaces, hyphens, or apostrophes only");

export const authNameSchema = makeAuthNameSchema();

export const authPhoneSchema = z
  .string()
  .trim()
  .min(1, "Phone number is required")
  .regex(/^[\d\s+()-]+$/, "Phone number contains invalid characters")
  .refine((value) => {
    const digits = value.replace(/\D/g, "");
    return digits.length >= 9 && digits.length <= 15;
  }, "Enter a valid phone number");
